import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';

import { TReduxActions, TThunkAction } from '../../types/redux';
import { getUserAction } from '../user/getUserAction';
import { fetchCreateTripReviewPageDataAction } from '../newReview/fetchCreateTripReviewPageData';

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  onSuccess?(): TThunkAction | TReduxActions;
  onCloseNoAuth?(): TThunkAction | TReduxActions;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

/**
 * Открывает модальное окно аутентификации и обрабатывает его события.
 *
 * @param parameters - необязательный объект параметров.
 * @param parameters.alert - тип предупреждения, которое нужно отобразить в модальном окне. Возможные значения: "favorites", "chats", "hide".
 * @param parameters.onSuccess - экшен, который нужно отправить, когда пользователь успешно аутентифицирован.
 * @param parameters.onCloseNoAuth - экшен, который нужно отправить, когда пользователь закроет модальное окно аутентификации.
 *
 * @returns thunk-экшен.
 */
export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return async (dispatch, _, { custom: { headerFrontendApi } }) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          // eslint-disable-next-line
          await dispatch(getUserAction());

          /* istanbul ignore else */
          if (window.__reloadHeader__) {
            window.__reloadHeader__();
          }

          // Обновляем данные для формы нового отзыва
          await dispatch(fetchCreateTripReviewPageDataAction());

          /* istanbul ignore else */
          if (parameters && parameters.onSuccess) {
            dispatch(parameters.onSuccess());
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          /* istanbul ignore else */
          if (parameters && parameters.onCloseNoAuth) {
            dispatch(parameters.onCloseNoAuth());
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      headerFrontendApi?.openAuthModal();
    }
  };
}
